module.exports = __webpack_public_path__ + "static/media/ic-notification-tick.bd0fa4f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-notification-tick.svg
// module id = 647
// module chunks = 14